module.exports = __webpack_public_path__ + "img/FO.a9e66110.svg";